import React, { Fragment, useState } from 'react';
import { Col, Card, Row } from 'reactstrap';
import { H4, H6, Image, LI, UL } from '../../../AbstractElements';
import { BinAccount, Complaints, Connections, Reward, Subscription } from '../../../Constant';
import StaticWidgets from '../../Widgets/General/StaticWidgets';
import defaultUserImage from '../../../assets/images/user-profile/default-users.png';

const UserProfile = (props) => {
    const personalDetails = props.details;
    const [userImage, setUserImage] = useState(''); 

    const handleFileSelect = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = function (e) {
                setUserImage(e.target.result);
            };
            reader.readAsDataURL(selectedFile);
        }
    };
    return (
        <Fragment>
            <Col sm="12" md='12'>
                <Card className="profile-header bg-size">
                    <Row>
                        <Col xl='5' sm="12" lg="5" md="12">
                            <div className="profile-img-wrrap">
                                {/* <Image attrImage={{ className: 'img-fluid bg-img-cover', src: `${require('../../../assets/images/user-profile/default-user.png')}`, alt: '' }} /> */}
                            </div>
                            <div className="userpro-box">
                                <div className="img-wrapper">
                                    <div className="avatar">
                                    <img className="step1" alt="default-image" src={userImage || defaultUserImage} data-intro="This is Profile image" />

                                    </div>
                                    <div className="icon-wrapper">
                                        <label htmlFor="fileInput" style={{paddingTop:'7px'}}>
                                            <i 
                                            className="icofont icofont-plus-circle step2" 
                                            data-intro="Change Profile image here">
                                            </i>
                                        </label>
                                        <input type="file" id="fileInput" style={{ display: 'none' }} accept="image/*" onChange={handleFileSelect} />
                                    </div>
                                </div>
                                <div className="user-designation">
                                    <div className="title"><a target="_blank" href="#javascript">
                                        <H4>{personalDetails.customer_name}</H4>
                                        <H6>{personalDetails.email}</H6>
                                        {/* <H6>Reward: {parseInt(personalDetails.reward_points)}</H6> */}
                                        </a></div>
                                    <div className="follow">
                                        <UL attrUL={{ className: 'follow-list flex-row simple-list' }}>
                                            <LI>
                                                <div className="follow-num counter">{personalDetails.connections}</div><span>{BinAccount}</span>
                                            </LI>
                                            <LI>
                                                <div className="follow-num counter">{parseInt(personalDetails.reward_points)}</div><span>{Reward}</span>
                                            </LI>
                                            <LI>
                                                <div className="follow-num counter">{personalDetails.complaints}</div><span>{Complaints}</span>
                                            </LI>
                                        </UL>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs='12' sm="12" lg="7" className='personalBusinessDetails'>
                            <Row className='profileCards'>
                                <StaticWidgets details={personalDetails} />
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Fragment>
    );
};

export default UserProfile;